import "./baseConfig/font.css.ts.vanilla.mjs";
import "./select.css.ts.vanilla.mjs";
var _ = "p273__select-a282_ced5fe9__10yn45c0";
export {
  _ as selectStyle
};
//# sourceMappingURL=select.mjs.map
